import React, { memo, useCallback } from 'react';
import { Button } from 'antd';
import { useModalState } from 'hooks/useModalState';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import ICatalog from 'icons/ICatalog';
import AssetCatalogModal, { AssetCatalogModalProps } from 'components/AssetCatalogModal/AssetCatalogModal';


export type AssetCatalogButtonProps = {
  styleModifiy?:boolean,
  noName?: boolean;
  fromextra?: boolean;
  currcode?: string;
} & Pick<AssetCatalogModalProps, 'onSelect'>;

const AssetCatalogButton = ({
  onSelect: onSelectProp,
  styleModifiy,
  noName,
  fromextra,
  currcode,
}: AssetCatalogButtonProps) => {
  const { getComponentLabel } = useDisplayFrameworkContext();
  const { close, open, visible } = useModalState();

  const onSelect = useCallback<AssetCatalogModalProps['onSelect']>(
    (asset, nbasset, selectedServices, selectedOption) => {
      onSelectProp(asset, nbasset, selectedServices, selectedOption);
      close();
    },
    [close, onSelectProp]
  );

  return (
    <>
      <Button
        onClick={open}
        icon={<ICatalog />}
        title="Select asset"
        style={styleModifiy?{width: '100%', height: 52}:fromextra?{ width: '100%', height: 60 }:{}}
      >
        {noName ? '' : getComponentLabel('catalog')}
      </Button>
      <AssetCatalogModal
        onCancel={close}
        onSelect={onSelect}
        visible={visible}
        currcode={currcode}
      />
    </>
  );
};

export default memo(AssetCatalogButton);
